import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './styles/ChangeImage.css';
import API_BASE_URL from '../config/api';

const API_URL = API_BASE_URL;
const HOST = process.env.REACT_APP_HOST || API_URL;

// 🔧 Helper para construir la URL completa de la foto
const resolvePhotoUrl = (raw) => {
  if (!raw) return '';
  const v = String(raw).trim();
  if (!v) return '';

  // Si ya es absoluta, la dejamos
  if (/^https?:\/\//i.test(v)) return v;

  // Si empieza con /, la colgamos del HOST (backend)
  if (v.startsWith('/')) return `${HOST}${v}`;

  // Por si viniera sin /
  return `${HOST}/${v}`;
};

const ChangeImage = ({ currentImage, onImageChange }) => {
  const navigate = useNavigate();

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(
    currentImage ? resolvePhotoUrl(currentImage) : ''
  );
  const [message, setMessage] = useState('');
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
      fetchProfileImage(storedUserId); // Cargar imagen actual
    } else {
      setMessage('❌ Error: ID de usuario no encontrado.');
    }
  }, []);

  // 🔹 Obtener la imagen actual del perfil
  const fetchProfileImage = async (userId) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/athletes/profile/${userId}`
      );
      const athlete = response.data.athlete || {};
      console.log('🔍 Imagen obtenida del backend:', athlete.profilePhoto);

      if (athlete.profilePhoto) {
        const baseUrl = resolvePhotoUrl(athlete.profilePhoto);
        setPreview(`${baseUrl}?t=${Date.now()}`); // Evitar caché
      } else {
        setPreview(resolvePhotoUrl('/uploads/athletes/default.jpg'));
      }
    } catch (error) {
      console.error('❌ Error al obtener la imagen de perfil:', error);
      setPreview(resolvePhotoUrl('/uploads/athletes/default.jpg')); // Imagen por defecto si hay error
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        setMessage('❌ Solo se permiten imágenes JPG o PNG.');
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setMessage('❌ La imagen no debe exceder 2MB.');
        return;
      }

      setImage(file);
      // Vista previa local antes de subir
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!image) {
      setMessage('⚠️ Por favor, selecciona una imagen.');
      setIsLoading(false);
      return;
    }

    if (!userId) {
      setMessage('❌ Error: ID de usuario no encontrado.');
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    // 👇 Debe llamarse igual que en upload.single('profilePhoto')
    formData.append('profilePhoto', image);

    console.log('🚀 Subiendo imagen para userId:', userId);
    try {
      const response = await axios.post(
        `${API_URL}/api/athletes/upload-photo/${userId}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      console.log('✅ Imagen subida:', response.data);
      setMessage('✅ Imagen actualizada correctamente.');

      // response.data.filePath = "/uploads/athletes/xxx.jpg"
      const baseUrl = resolvePhotoUrl(response.data.filePath);
      const newImageUrl = `${baseUrl}?t=${Date.now()}`; // Evitar caché

      setPreview(newImageUrl); // Actualizar la vista previa

      if (typeof onImageChange === 'function') {
        onImageChange(newImageUrl);
      }

      setTimeout(() => navigate('/athlete-profile'), 2000); // Redirigir al perfil
    } catch (error) {
      setMessage('❌ Error al actualizar la imagen.');
      console.error('❌ Error al subir la imagen:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="change-image-container">
      {/* Botones de navegación */}
      <div className="d-flex justify-content-between mb-3">
        <button
          className="btn btn-warning"
          onClick={() => navigate('/athlete-dashboard')}
        >
          Volver al Dashboard
        </button>
        <button
          className="btn btn-warning"
          onClick={() => navigate('/athlete-profile')}
        >
          Volver al Perfil
        </button>
      </div>

      <h2 className="text-center">Cambiar Imagen de Perfil</h2>

      <div className="image-preview">
        <img
          src={preview || resolvePhotoUrl('/uploads/athletes/default.jpg')}
          alt="Vista previa"
          onError={(e) => {
            console.error('❌ Error al cargar la imagen:', e.target.src);
            e.target.onerror = null;
            e.target.src = resolvePhotoUrl('/uploads/athletes/default.jpg');
          }}
        />
      </div>

      <input type="file" accept="image/*" onChange={handleImageChange} />
      <button onClick={handleSubmit} className="btn-upload" disabled={isLoading}>
        {isLoading ? 'Subiendo...' : 'Subir Imagen'}
      </button>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default ChangeImage;
